import { useLocation } from '@tanstack/react-location';
import { useEffect } from 'react';

export default function ScrollToTop() {
  const {
    current: { pathname },
  } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
